import type { IconType } from "../../../../utils/Icons/Icon";
import Icon from "../../../../utils/Icons/Icon";
import "./index.scss";

interface ImportTypeCardProps {
  active?: boolean;
  onClick?(): void;
  label: string;
  description: string;
  iconName: IconType;
}

export default function ImportTypeCard({
  active,
  onClick,
  label,
  description,
  iconName,
}: ImportTypeCardProps) {
  return (
    <button type="button" className={`ImportTypeCard ${active ? "active" : ""}`} onClick={onClick}>
      <input type="radio" className="ImportTypeCard-radio" checked={active} readOnly />
      <div className="ImportTypeCard-texts">
        <Icon name={iconName} width={24} height={24} />
        <p className="ImportTypeCard-label">{label}</p>
        <p className="ImportTypeCard-description">{description}</p>
      </div>
    </button>
  );
}
